package org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.bill_search.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.statistic_data.BillSearchStatisticDataItem
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton


@Composable
fun BillSearchTableContent(
    modifier: Modifier=Modifier,
    windowSizeMode: WindowSizeModeEnum,
    selectedBillSearchStatisticItem:BillSearchStatisticDataItem?,
    statisticData:List<BillSearchStatisticDataItem>?,
    onSelectStatisticItem:(BillSearchStatisticDataItem)->Unit,
    searchBillSearchItems:(String)->Unit,
    getBillPdf:(String,String,String)->Unit,
    exportStatisticReports:(List<BillSearchStatisticDataItem>?)->Unit,
)
{
    Column(
        modifier = modifier
            .fillMaxWidth(),
    )
    {
        MediumContentTitle(
            title = Strings.current().receiptsList
        )

        Row(
            modifier=Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        )
        {


            CustomIcon(
                modifier=Modifier
                    .margin(right = Dimen.normalPadding),
                iconColor = Theme.PrimaryMain.hex,
                tooltipText = Strings.current().exportExcel,
                icon = Res.PathIcon.excel,
                onIconClick = {
                    if (!statisticData.isNullOrEmpty())
                        exportStatisticReports(statisticData)
                }
            )

            CustomIcon(
                iconColor = Theme.PrimaryMain.hex,
                icon = Res.PathIcon.pdf2,
                tooltipText = Strings.current().pdf,
                onIconClick = {
                    if (selectedBillSearchStatisticItem!=null){
                        getBillPdf(
                            selectedBillSearchStatisticItem.number?:"",
                            selectedBillSearchStatisticItem.dateTime?:"",
                            selectedBillSearchStatisticItem.cashRegisterId?:""
                        )
                    }

                }
            )

            Spacer()

            CustomEditText(
                modifier = modifier,
                label = "",
                value = "",
                width =Dimen.semiLargeEditTextWidth,
                endIconPath = Res.PathIcon.searchBox,
                fillMaxWidth = windowSizeMode== WindowSizeModeEnum.PHONE,
                isRequired = false,
                hasLabelSpace = false,
                marginBottom =Dimen.normalPadding,
                hint = Strings.current().search,
                marginRight = Dimen.normalPadding,
                onFocusIn = {},
                onFocusOut = {},
                onInputChange = {it, validation ->
                    searchBillSearchItems(it)
                },
            )

        }


        BillSearchTable(
            windowSizeMode=windowSizeMode,
            statisticData=statisticData ,
            showRefreshIcon = false,
            selectedBillSearchItem =selectedBillSearchStatisticItem ,
            onItemClick = {
                onSelectStatisticItem(it)
            },
        )



    }


}